import { useMutation, useQuery } from 'react-query';
import { POST } from './http-service';
import { useClientStateDataUpdate } from 'hooks/clientStateData';

export const Links = ({ journeyGuid, processGuid: processGUID, lngCode, clientStateData, customerGUIDFromJWT, journeyGuidFromApi, useMock }) => {
    const baseApi = `${lngCode}`;
    const clientStateDataUpdate = useClientStateDataUpdate();
    return {
        useLinksQuery(propertyId, enabled) {
            return useQuery(['active-query', 'beforeredirect', lngCode, propertyId],
                () => getLinks(propertyId),
                { enabled },
            );
        },
        useMutationBeforeRedirect() {
            return useMutation({
                mutationFn: async ({ propertyId }) => {
                    if (useMock) {
                        return Promise.resolve(() => {
                            return { urlHref: '' }
                        })
                    }
                    const params = {
                        identity: journeyGuid,
                        processGUID,
                        lngCode,
                        clientStateData,
                        propertyId
                    }

                    return POST(`${baseApi}/links/beforeredirect`, params);
                }

            })
        }
    };

    async function getLinks(propertyId) {


        if (useMock) {
            return Promise.resolve(() => {
                return { urlHref: '' }
            })
        }

        const params = {
            identity: journeyGuidFromApi,
            processGUID,
            lngCode,
            propertyId,
            clientStateData
        }
        const response = POST(`${baseApi}/links/beforeredirect`, params)
        if (response.clientStateData) { clientStateDataUpdate(response.clientStateData) }
        return response
    }

}